export function getNextPowerOfTwo(n: number): number {
    if (!Number.isInteger(n) || n < 0) {
        throw new Error("Input must be a non-negative integer.")
    }

    // Handle the edge case of 0, which would otherwise return 0.
    // The next power of two after 0 is 1.
    if (n === 0) {
        return 1
    }

    // 1. Decrement n.
    // This is the crucial part that handles
    // numbers that are already a power of two.
    // (e.g., 8 becomes 7, so the result is 8, not 16)
    n--

    // 2. Smear the highest bit to the right.
    // (Assumes 32-bit integers)
    n |= n >> 1
    n |= n >> 2
    n |= n >> 4
    n |= n >> 8
    n |= n >> 16

    // 3. Increment n.
    // The number is now all 1s (e.g., 7, 15, 31)
    // Adding 1 gives the next power of two (e.g., 8, 16, 32).
    n++

    return n
}
